import { declareFieldMeanings, identity, means } from '../../../src/issues/field-meanings';

/** What each tax bill detail means to an owner: amounts and dates the Tax Collector states. */
const OWE = 'changes what you owe';
export const fieldMeanings = declareFieldMeanings({
  sources: ['sf-treasurer'],
  declarations: [
    identity('paymentPlanBillNumber', 'label'),
    means('amount', 'the total tax on this bill', ['totalTax'], { matters: OWE }),
    means('amount', 'the balance still owed on an installment', ['amountDue'], { matters: OWE }),
    means('amount', 'the amount the Tax Collector shows as paid', ['paidAmount'], {
      matters: 'means a payment was posted or reversed',
    }),
    means('status', 'the installment status', ['status']),
    means('date', 'the date a payment was posted', ['paidOn']),
    means('deadline', 'the delinquency date', ['delinquentAfter'], {
      matters: 'moves the date after which penalties apply',
    }),
  ],
});
